import Component from '../core/Component'
import Scroll from '../services/Scroll'

export default class ShapePath extends Component {
    constructor(element) {
        super(element)

        this.ref = {
            anchors: [],
        }

        this.state = {
            disabled: false,
            active: true,
            scrollLimit: 0,
        }

        this.curve = null
    }

    prepare() {
        this.state.disabled = this.ref.anchors.length === 0
        Scroll.on('resize', this.handleResize)
        Scroll.on('scroll', this.handleScroll)
        this.shape = Component.getFromElement('shape')
        if (this.state.disabled) {
            this.shape.disable()
        } else {
            this.shape.enable()
        }
        this.resize()
    }

    destroy() {
        Scroll.off('resize', this.handleResize)
        Scroll.off('scroll', this.handleScroll)
        this.shape = null
    }

    handleResize = () => {
        if (this.state.disabled) {
            return
        }
        this.resize()
    }

    handleScroll = ({ offset }) => {
        if (this.state.disabled) {
            return
        }
        this.render(offset.y)
    }

    resize() {
        const scroll = Scroll.getScroll()
        const windowWidth = window.innerWidth
        const windowHeight = window.innerHeight

        this.state.scrollLimit = Scroll.getLimit().y

        this.points = this.ref.anchors
            .map((element) => {
                if (!element.dataset.coords) {
                    return null
                }

                const box = element.getBoundingClientRect()
                const coords = JSON.parse(element.dataset.coords)

                const offset = box.top + scroll.y

                const x = (windowWidth * coords.x) / 4
                const y = (windowHeight * coords.y) / 4

                return {
                    x,
                    y,
                    threshold: offset / this.state.scrollLimit,
                }
            })
            .filter(Boolean)
    }

    render(y) {
        if (!this.state.active) {
            return
        }
        const progress = y / this.state.scrollLimit

        let start = null
        let end = null

        let coords = {
            x: 0,
            y: 0,
        }

        this.points.forEach((point) => {
            if (point.threshold <= progress) {
                start = point
            }

            if (point.threshold > progress && !end) {
                end = point
            }
        })

        if (start && end) {
            const dist = {
                x: end.x - start.x,
                y: end.y - start.y,
                threshold: end.threshold - start.threshold,
            }

            const diff = (progress - start.threshold) / dist.threshold

            coords.x = start.x + dist.x * diff
            coords.y = start.y + dist.y * diff
        } else if (!end) {
            coords.x = start.x
            coords.y = start.y
        } else if (!start) {
            coords.x = this.points[0].x
            coords.y = this.points[0].y
        }

        this.shape.positionSpring.to({
            x: coords.x,
            y: coords.y,
        })
    }
}
